import { defineStore } from 'pinia'

export type iParamsNotification = {
  first_time_date: number;
  first_show: boolean;
  timer_show: string;
  days_next: string;
  wp_key: string;
};
export const notificationStore = defineStore('notification', {
  state: () => ({
    bellaNotifications: {} as iParamsNotification
  }),
  actions: {
    async setNotificationsParams(payload: iParamsNotification) {
      this.bellaNotifications = payload
    },
    async resetNotificationsParams() {
        localStorage.removeItem('bellaNotifications');
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'bellaNotifications',
        storage: localStorage,
      },
    ],
  }
})
